import React from "react"
import { Handle } from "react-flow-renderer";
import { getConnectionType, NodeCaption, NodeWindow, NodeContent, NodeWrapper, HandleInput, HandleOutputWrapper } from "../";

export const NodeOperation = React.memo((props) => {

  const { id, data } = props;
  const { bgColor, nombre = "", descripcion = "", onEdit, onRemove, input = true } = data;

  return (
    <NodeWrapper bgColor={bgColor}>
      {input &&
        <Handle
          type="target"
          position="left"
          isConnectable={true}
          style={{  
            borderRadius: "5px 0px 0px 5px", 
            height: "100%", 
            border: "0px solid #7371b5", 
            width: "10px",
            left: "-8px",
            transform: "translateY(0%)", 
            top: "0px",
            opacity: 0.8,
            backgroundColor: "green",
          }}
          isValidConnection={(connection) => true}
          onConnect={(params) => console.log('handle onConnect', params)}

        />
      }
      <NodeWindow 
        caption={
          <NodeCaption title={nombre} onClickEdit={()=>onEdit(props)} onClickRemove={()=>onRemove(props)}/>
        }
      >
        {descripcion && 
          <NodeContent>
            {descripcion}
          </NodeContent>
        }
      </NodeWindow>
      <Handle
        type="source"
        position="right"
        style={{  backgroundColor: "red", transform: "translateY(0%)", top: "0px", bottom: "unset", borderRadius: "0px 5px 5px 0px", height: "100%", border: "0px solid white", width: "10px", right: "-8px"  }}
        isConnectable={true}
        isValidConnection={(connection) => true}
        onConnect={(params) => console.log('handle onConnect', params)}
      />
    </NodeWrapper>
  );
});
